export default __webpack_public_path__ + "static/media/IndianFlag.6ac4ab89.webp";